import { DescriptionText, ErrorMessage, RetryButton } from '@components/ErrorMessage';
import { acceptedFileFormats } from '@constants/URLs';
import { faArrowRight, faCircleExclamation } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useMediaQuery } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { device } from 'src/constants/mediaQueries';

export function CADErrorState({ productName, runID }: Readonly<{ productName: string; runID: string }>) {
  const { t } = useTranslation('createProduct');
  const isMobile = useMediaQuery(device.mobileOrTablet);

  return (
    <ErrorMessage header={t('ranIntoError', { productName })} icon={faCircleExclamation}>
      <DescriptionText>
        {t('errorReference')} <span>{runID}</span>
      </DescriptionText>
      <DescriptionText>
        {t('checkKnowledgeBase')}{' '}
        <a href={acceptedFileFormats} target="_blank" rel="noreferrer">
          {t('knowledgeBase')}
        </a>
        .
      </DescriptionText>
      <DescriptionText>{t('tryUploadingAgain')}</DescriptionText>
      <RetryButton
        variant="contained"
        size={isMobile ? /* istanbul ignore next */ 'medium' : 'large'}
        endIcon={<FontAwesomeIcon icon={faArrowRight} size="3x" />}
        type="button"
        data-testid="upload-again-button"
        to={`/create-product/cad?runID=${runID}`}
        component={Link}
      >
        {t('uploadANewFile')}
      </RetryButton>
    </ErrorMessage>
  );
}
